import perfectPairLight from "../../../../src/pages/whats-new/typography-and-iconography-updates/_assets/perfect-pair.light.png";
import perfectPairDark from "../../../../src/pages/whats-new/typography-and-iconography-updates/_assets/perfect-pair.dark.png";
import iconsLight from "../../../../src/pages/whats-new/typography-and-iconography-updates/_assets/icons.light.png";
import iconsDark from "../../../../src/pages/whats-new/typography-and-iconography-updates/_assets/icons.dark.png";
import * as React from 'react';
export default {
  perfectPairLight,
  perfectPairDark,
  iconsLight,
  iconsDark,
  React
};